import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  filesContainer: ({ fileUploads }) => ({
    background: 'transparent',
    display: fileUploads.length > 0 ? 'flex' : 'none',
    justifyContent: 'flex-start',
    margin: '15px auto 10px auto',
    width: '90%'
  })
})

export default useStyles
